import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  route: string | null; // null = current page (non-clickable)
  /**
   * Query params del enlace (p. ej. `{ game: 'one-piece' }` → `/blog?game=one-piece`).
   * Opcional: meter el `?` dentro de `route` no sirve, `routerLink` lo escapa a `%3F`.
   */
  queryParams?: Record<string, string>;
}

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterLink],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class BreadcrumbComponent {
  items = input.required<BreadcrumbItem[]>();
}
